import '../../resources/css/common/ModalPickupList.scss';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Modal, Button } from 'react-bootstrap';
import { closePickModal, savePickModal, MODAL_PICK_SAVE, openModalAlert } from '../../actions/index';
import { ReactTabulator } from 'react-tabulator';
import Loading from '../../components/common/Loading';

let checked;
class ModalPickList extends Component {
 
  constructor(props) {
    super(props);
 
    this.updateDataList = this.updateDataList.bind(this);
    this.state = {
      dataList: false
    }
  }

  closeModal = () => {
    const { closePickModal } = this.props;
    if (this.ref) {
      const rows = this.ref.table.getRows();
      rows.forEach(row => {
        let checkCell = row._row.getCell('PICK_CHECKED');
        if (checkCell.getValue()) {
          checkCell.setValue(0);
        }
      });
    }
    closePickModal(null);
  }
 
  updateDataList() {
    const dataList = (this.props.dataList) ? this.props.dataList : false;
    this.setState({
      dataList: dataList
    });
  }
 
  saveClick = (e) => {
    const { table } = this.ref;
    if (table.getSelectedRows().length > 0) {
      const { modalPick } = this.props;
      if (modalPick.modalStatus === 'PickCADeviceList') {
        this.saveCADevice();
      } else {
        this.savePick();
      }
    }
    else {
      const { openModalAlert } = this.props;
      openModalAlert('Please assign first!');
    }
  }
 
  savePick = () => {
    const { modalPick, savePickModal, isMultiChoose, selectMultiCol, pickUniqueId } = this.props;
    const { dataList } = this.state;
 
    if (isMultiChoose) {
      checked = [];
    }
 
    dataList.forEach(data => {
      if (data.PICK_CHECKED) {
        let key = pickUniqueId.split(',');
        if (typeof data[key[0]] !== 'undefined') {
          let customObj = {};
          customObj[key[0]] = data[key[0]];
          customObj[key[1]] = data[key[1]];
          customObj[key[2]] = data[key[2]];
          customObj[key[3]] = data[key[3]];
          if (isMultiChoose) {
            checked.push(selectMultiCol ? data : customObj);
          } else {
            checked = selectMultiCol ? data : customObj;
          }
        }
      }
    })
 
    savePickModal(modalPick.modalStatus, modalPick.modalAction, checked, MODAL_PICK_SAVE, () => this.closeModal());
  }
 
  saveCADevice = () => {
    const { modalPick, savePickModal, isMultiChoose } = this.props;
    const { dataList } = this.state;
 
    let checked;
    if (isMultiChoose) {
      checked = [];
    }
 
    dataList.forEach(data => {
      if (data.PICK_CHECKED) {
        // let key = pickUniqueId.split(',');
        // if (typeof data[key[0]] !== 'undefined') {
          if (isMultiChoose) {
            checked.push(data);
          } else {
            checked = data;
          }
        // }
      }
    })
 
    savePickModal(modalPick.modalStatus, modalPick.modalAction, checked, MODAL_PICK_SAVE, () => this.closeModal());
  }
 
  renderTable = () => {
    const { columns, isMultiChoose, checkHasGroup, openModalAlert } = this.props;
    const { dataList } = this.state;
    checked = [];
    if (dataList) {
      const options = {
        movableRows: false,
        selectable: true
      };
      
      return (
        <ReactTabulator
          ref={ref => (this.ref = ref)}
          columns={columns}
          data={dataList}
          placeholder="No data found"
          options={options}
          data-custom-attr="test-custom-attribute"
          className="custom-list-table"
          rowClick={(e, row) => {
            let checkCell = row._row.getCell('PICK_CHECKED');
            if (isMultiChoose) {
              if (checkCell.getValue()) {
                checkCell.setValue(0);
              } else {
                checkCell.setValue(1);
              }
            } else {
              const table = row._row.table;
              const tableRows = table.getRows();
              // check has choose other value
              tableRows.forEach(tableRow => {
                let tableRowCheckCell = tableRow._row.getCell('PICK_CHECKED');
                if (tableRowCheckCell.getValue()) {
                  tableRowCheckCell.setValue(0);
                  tableRow.deselect();
                }
              });
              checkCell.setValue(1);
              row.select();
              
              if (checkHasGroup && (row._row.data.group === 0)) {
                openModalAlert('Please assign device to group first!');
                checkCell.setValue(0);
              }
            }
          }}
          rowFormatter={(row) => {
            const cell = row.getCell("guestPortalName");
            const guestPortalEnabled = row.getData().guestPortalEnabled;
            if (guestPortalEnabled === false) {
              cell.setValue("NA");
            }
          }}
        />
      )
    } else {
      return (
        <Loading loading={true}></Loading>
      )
    }
  }
 
  componentDidMount() {
    // if call render will do this method
    this.updateDataList();
  }
 
  componentDidUpdate (prevProps, prevState, snapshot) {
    // if props change will call this method
    if (prevProps.dataList !== this.props.dataList) {
      this.updateDataList();
    }    
  }
 
  render() {
    const { modalPick, modalName, modalTitle } = this.props; 
    const { dataList } = this.state;
    const show = modalPick.modalStatus === modalName;
    const saveBtnStatus = !dataList || (dataList && dataList.length === 0);
    const saveBtnClass = saveBtnStatus ? 'btn btn-save btn-disable' : 'btn btn-save';
 
    let renderContent;
    if (show) {
      renderContent = (
          <Modal
              show={show}
              dialogClassName='modal-picup-list'
              centered
              onHide={() => this.closeModal()}
          >
              <Modal.Body>
                  <div className='area-modal-detail-header'>
                      <Row>
                          <Col sm={6} className='area-modal-title'>
                              <label>{ modalTitle }</label>
                          </Col>
                          <Col sm={6} className='area-close-btn'>
                            <span className='area-icon-close-detail' onClick={() => this.closeModal()}><span className="icon-btn-close-n"></span></span>
                          </Col>
                      </Row>
                  </div>
                  <div className='area-modal-detail-content'>
                    <div className='area-picup-list'>
                      { this.renderTable() }
                    </div>
                    <hr/>
                    <div className='area-btns'>
                      <Row className='area-btn-save'>
                          <Col><Button type="button" variant="primary" onClick={() => this.closeModal()} block bsPrefix='btn btn-close'>Cancel</Button></Col>
                          <Col><Button type="button" variant="primary" onClick={ this.saveClick } block bsPrefix={saveBtnClass} disabled={saveBtnStatus}>Confirm</Button></Col>
                      </Row>
                    </div>
                  </div>
                 
              </Modal.Body>
          </Modal>
      )
    } else {
      renderContent = (<div className='modal-detail-empty'></div>);
    }
 
    return (
      <div className='area-account-role-detail'>
          {renderContent}
      </div>
    )
  }
}
 
const mapStateToProps = (state, ownProps) => {
  return {
    modalPick: state.commonReducers.modalPick
  }
}
 
export default connect(
  mapStateToProps,
  { closePickModal, savePickModal, openModalAlert }
)(ModalPickList)

